import Dynamics365Hydrovault from "../Pages/Dynamics365QuoteProductPages/Dynamics365Hydrovault";
import React from "react";
import { Routes, Route } from "react-router-dom";
import SignupPage from "../Pages/signupPage";
import DashBoardPage from "../Pages/dashBoardPage";
import EmailConfirmationPage from "../Pages/emailConfirmationPage";
import CaseStudiesPage from "../Pages/caseStudiesPage/caseStudiesPage";
import { AuthProvider } from "../Helpers/auth-context";
import ProtectedRoute from "./ProtectedRoute";
import EmailVerificationPage from "../Pages/emailVerificationPage";
import PleaseCheckYourEmailPage from "../Pages/pleaseCheckYourEmailPage";
import ProductHomePage from "../Pages/productHomePage/productHomePage";
import ForgotPasswordPage from "../Pages/forgotPasswordPage";
import ResetPasswordPage from "../Pages/ResetPasswordPage";
import LoginPage from "../loginPage";
import FileStoragePage from "../Pages/fileStoragePage";
import ProjectsPage from "../Pages/projectsPage";
import ClientFormPage from "../Pages/warrantyQuotePages/clientFormPage";
import EditProjectPage from "../Pages/warrantyQuotePages/editProjectPage";
import WarrentyManagementPage from "../Pages/warrantyQuotePages/warrantyManagementPage";
import WarrentyDetailPage from "../Pages/warrantyQuotePages/warrentyDetailPage";
import { AutoLogoutProvider } from "../Helpers/AutoLogoutProvider";
import DesignToolPage from "../Pages/designToolPage/designToolPage";
import PumpStationForm from "../Pages/testPage";
import ProductQuoteCalculator from "../Pages/QuotePricePage/productQouteCalculator";
import AccessCoverPriceTable from "../Pages/QuotePricePage/AccessCoverPriceTable";
import PumpStationPriceTablesDashBoardPage from "../Pages/QuotePricePage/PumpStationPriceTablesDashBoardPage";
import ControllerPriceTable from "../Pages/QuotePricePage/ControllerPriceTable";
import LevelControlPriceTable from "../Pages/QuotePricePage/LevelControlPriceTable";
import MixerPriceTable from "../Pages/QuotePricePage/MixerPriceTable";
import PedestalPriceTable from "../Pages/QuotePricePage/PedestalPriceTable";
import PipeWorkPriceTable from "../Pages/QuotePricePage/PipeWorkPriceTable";
import PumpPriceTable from "../Pages/QuotePricePage/PumpPriceTable";
import TankPriceTable from "../Pages/QuotePricePage/TankPriceTable";
import ValvePitPriceTable from "../Pages/QuotePricePage/ValvePitPriceTable";
import XtrCalculatorPage from "../Pages/xtrCalculatorPage";
import GuideRailPriceTable from "../Pages/QuotePricePage/GuideRailPriceTable";
import DocumentManager from "../Pages/DocumentManagerPage/DocumentManager";
import PlayGround from "../Pages/PlayGround";
import QuoteProductForm from "../Pages/QuoteProductForm";
import Dynamics365EcoProtector from "../Pages/Dynamics365QuoteProductPages/Dynamics365EcoProtector";
import Dynamics365EcoProtector1 from "../Pages/Dynamics365QuoteProductPages/Dynamics365EcoProtector1";

import CPQHomePage from "../Pages/Dynamics365QuoteProductPages/CPQHomePage";
import FreightCompanyTable from "../Pages/FreightCompanyTable";
import FreightCompanyContactTable from "../Pages/FreightCompanyContactTable";
import JutsTransportFreightRateTable from "../Pages/QuotePricePage/JutsTransportFreightRateTable";
import CPQSettingPage from "../Pages/Dynamics365QuoteProductPages/CPQSettingPage";
import PumpStationFreightSettingPage from "../Pages/QuotePricePage/PumpStationFreightSettingPage";
import Dynamics365TornadoGPTOffline from "../Pages/Dynamics365QuoteProductPages/Dynamics365TornadoGPTOffline";
import CubeConfigurator from "../Pages/CubeConfigurator";
import EcoprotectorConfigurator from "../Pages/EcoprotectorConfigurator";
import AscoraProjectsPublisher from "../Pages/AscoraProjectsPublisher/AscoraProjectsPublisher";
function AppRoutes() {
    return (
        <AuthProvider>
            <AutoLogoutProvider>
                <Routes>
                    <Route path="/CubeConfigurator" element={<CubeConfigurator />} />
                    <Route path="/EcoprotectorConfigurator" element={<EcoprotectorConfigurator />} />

                    <Route path="/pumpstation-freight-setting" element={<PumpStationFreightSettingPage />} />
                    <Route path="/dynamics-tornado-gpt-offline" element={<Dynamics365TornadoGPTOffline />} />
                    <Route path="/cpq-setting" element={<CPQSettingPage />} />
                    <Route path="/freight-company-table" element={<FreightCompanyTable />} />
                    <Route path="/freight-company-contacts" element={<FreightCompanyContactTable />} />
                    <Route path="/juts-transport-freight-rate" element={<JutsTransportFreightRateTable />} />
                    <Route path="/playground" element={<PlayGround />} />
                    <Route path="/cpq-home" element={<CPQHomePage />} />
                    <Route path="/dynamics-hydrovault" element={<Dynamics365Hydrovault />} />
                    <Route path="/dynamics-ecoprotector" element={<Dynamics365EcoProtector />} />
                    <Route path="/dynamics-ecoprotector1" element={<Dynamics365EcoProtector1 />} />
                    {/* <Route path="/dynamics-ecoprotector" element={<Dynamics365EcoProtector />} /> */}
                    <Route path="/quoteproductform" element={<QuoteProductForm />} />
                    <Route path="/pdf-manager" element={<DocumentManager />} />
                    {/* pumpstationtables section */}
                    <Route path="/pumpstation-setting" element={<PumpStationPriceTablesDashBoardPage />} />
                    <Route path="/access-cover-price-table" element={<AccessCoverPriceTable />} />
                    <Route path="/controller-price-table" element={<ControllerPriceTable />} />
                    <Route path="/level-control-price-table" element={<LevelControlPriceTable />} />
                    <Route path="/mixer-price-table" element={<MixerPriceTable />} />
                    <Route path="/pedestal-price-table" element={<PedestalPriceTable />} />
                    <Route path="/pipe-work-price-table" element={<PipeWorkPriceTable />} />
                    <Route path="/pump-price-table" element={<PumpPriceTable />} />
                    <Route path="/tank-price-table" element={<TankPriceTable />} />
                    <Route path="/guideRail-price-table" element={<GuideRailPriceTable />} />
                    <Route path="/valve-pit-price-table" element={<ValvePitPriceTable />} />
                    {/* end of pumpstationtables section */}
                    <Route path="/tool" element={<DesignToolPage />} />
                    <Route path="/test" element={<PumpStationForm />} />
                    <Route
                        path="/dynamics-pump-station"
                        element={
                            // <ProtectedRoute>
                            <ProductQuoteCalculator />
                            // </ProtectedRoute>
                        }
                    />
                    <Route path="/signup" element={<SignupPage />} />
                    <Route path="/login" element={<LoginPage />} />
                    <Route
                        path="/dashboard"
                        element={
                            <ProtectedRoute>
                                <DashBoardPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="/case-studies" element={<CaseStudiesPage />} />
                    <Route path="/forgot-password" element={<ForgotPasswordPage />} />
                    <Route path="/reset-password" element={<ResetPasswordPage />} />
                    <Route path="/projects" element={<ProjectsPage />} />
                    <Route path="/projects/:projectId/files" element={<FileStoragePage />} />
                    {/* Newly added routes */}
                    <Route path="/form/:token" element={<ClientFormPage />} />
                    <Route path="/warrenty/edit/:id" element={<EditProjectPage />} />
                    <Route path="/warrenty" element={<WarrentyManagementPage />} />
                    <Route path="/warrenty/detail/:id" element={<WarrentyDetailPage />} />
                    {/* Newly added routes */}
                    <Route path="/verify-email" element={<EmailVerificationPage />} />
                    <Route path="/check-your-email" element={<PleaseCheckYourEmailPage />} />
                    <Route path="/xtr" element={<XtrCalculatorPage />} />
                    <Route path="/confirmation-success" element={<EmailConfirmationPage />} />
                    <Route path="/ascora-shopify-publisher" element={<AscoraProjectsPublisher />} />
                    <Route path="/" element={<ProductHomePage />} />
                    {/* <Route path="/signalrdebug" element={<SignalRDebugPanel />} /> */}

                    <Route path="*" element={<h1>404 Not Found</h1>} />
                </Routes>
            </AutoLogoutProvider>
        </AuthProvider>
    );
}

export default AppRoutes;
